//import { useEffect, useRef, useState } from 'react'
import * as React from 'react'
import IconMenuUser from '../../../assets/icons/ico-menu-user.png'
import IconMenuMyAccounts from '../../../assets/icons/ico-menu-my-accounts.png'
import IconMenuUsersFarms from '../../../assets/icons/ico-menu-users-farms.png'
import IconMenuSignOut from '../../../assets/icons/ico-menu-sign-out.png'
import UserMenuItem from './user-menu-item'
import { Container } from './styles'
import { handleBlockedButtons } from 'presentation/utils/helpers/helpers'
import { clearCookies, clearStorage } from 'infra/services/auth'
import { translate } from './../../../../i18n/index'
import { Link, useLocation, useHistory } from 'react-router-dom'
import { Button, Menu, Typography } from '@mui/material'
import { CreditCard, Logout } from '@mui/icons-material'

const UserMenu = () => {
  const ref = React.useRef(null)
  const history = useHistory()
  const farmName = window.localStorage.getItem('farm-name') ? atob(window.localStorage.getItem('farm-name')) : ''
  const farmKey = window.localStorage.getItem('farm-api-key') ? atob(window.localStorage.getItem('farm-api-key')) : ''
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const [userName, setUserName] = React.useState('--')
  const [siglaName, setSiglaName] = React.useState(userName)

  React.useEffect(() => {
    const interval = setInterval(() => {
      const name = window.localStorage.getItem('user-name')
      if (name) {
        const decodedName = atob(name)
        setUserName(decodedName)
        setSiglaName(decodedName.length > 1 ? decodedName.slice(0, 2).toUpperCase() : '--')
        clearInterval(interval)
      }
    }, 100)

    return () => clearInterval(interval)
  }, [])

  const logout = () => {
    clearStorage()
    clearCookies()
    window.location.href = `${process.env.REACT_APP_SIGNIN_URL}/logout`
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Container ref={ref}>
      <Button
        id="basic-button"
        aria-controls={open ? 'menu-main' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        {siglaName}
      </Button>
      <Menu
        id="menu-main"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top', // <- Ponto de origem do menu (ajustado!)
          horizontal: 'right'
        }}
      >
        <div className="user-menu-drop seta-cima">
          <div className="user-menu-drop-title">
            <div className='divSiglaName'>
              {siglaName}
            </div>
            <div style={{ width: '100%' }}>
              <Typography>{userName.toUpperCase()}</Typography>
              <Typography>#{farmKey}</Typography>
              <Typography>{farmName}</Typography>
            </div>
          </div>
          {<UserMenuItem type={'meusDados'} icon={IconMenuUser} title={translate('labelMeusDados')} hasDrop itens={[
            { title: translate('labelDadosUsuario'), url: '/meus-dados/dados-do-usuario', actionSubItem: () => { handleClose(); } },
            { title: translate('labelDadosFazenda'), url: '/meus-dados/dados-da-fazenda', actionSubItem: () => { handleClose(); } },
            { title: translate('labelAlterarSenha'), url: '/meus-dados/alterar-senha', actionSubItem: () => { handleClose(); } }
          ]} />}
          {handleBlockedButtons('ROLE_APP_MINHAS_CONTAS') && (
            <Link
              className='menuMainItem'
              onClick={() => {
                handleClose()
              }}
              to={{ pathname: '/minhas-contas', state: history.location.pathname }}
            >
              <CreditCard style={{ color: '#8C2458', fontSize: 26 }} />
              <span style={{ fontSize: 16, color: '#343A40', fontWeight: 500 }}>{translate('labelMinhasContas')}</span>
            </Link>
          )}
          {handleBlockedButtons('ROLE_APP_USUARIOS_FAZENDAS') && (
            <UserMenuItem type={'usuarioFazendas'} icon={IconMenuUsersFarms} title={translate('labelUsuarioFazendas')} hasDrop itens={[
              { title: translate('labelUsuarios'), url: '/usuarios', actionSubItem: () => { handleClose(); } },
              { title: translate('labelFazendas'), url: '/fazendas', actionSubItem: () => { handleClose(); } },
              { title: translate('labelAlternarFazenda'), action: () => { clearStorage(); window.location.href = `${process.env.REACT_APP_SIGNIN_URL}/selecionar-fazenda`; } }
            ]} />
          )}
          <Link
            className='menuMainItem'
            onClick={() => {
              handleClose()
              logout()
            }}
            to={{ pathname: null }}
          >
            <Logout style={{ color: '#8C2458', fontSize: 26 }} />
            <span style={{ fontSize: 16, color: '#343A40', fontWeight: 500 }}>{translate('labelSair')}</span>
          </Link>
        </div>
      </Menu>
    </Container>
  )
}

export default UserMenu
